import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Figma schedule list row (ProtocolSteps / Schedule under Other Schedules). */
@Component({
  selector: 'eventq-schedule-entry',
  templateUrl: './schedule-entry.html',
  styleUrl: './schedule-entry.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqScheduleEntry {
  /** Vendor rows only — omitted for Business Hours / Worker Schedule. */
  readonly title = input<string | null>(null);
  readonly days = input.required<string>();
  readonly time = input.required<string>();
  readonly calendarIconSrc = input.required<string>();
  readonly clockIconSrc = input.required<string>();
}
